/**
 * Fixed option sets for the Astha Sthaana Pareeksha and Prakruthi/Dosha/Aama
 * chip fields, mirrored exactly from the backend's Literal definitions in
 * p4h-avatars/src/agents/physician_standalone_ayurveda/schema/clinical_profile_schema.py.
 */

export const NADI_OPTIONS = [
  'Vatha',
  'Pitha',
  'Kapha',
  'Tridoshajam',
  'Vathakapha',
  'Vathapitha',
  'Kapha Pitha',
  'Sannipatika',
] as const;
export const MOOTRAM_OPTIONS = ['Prakrutha', 'Vikrutha'] as const;
export const MALAM_OPTIONS = ['Krooram', 'Mrudu', 'Madhyamam'] as const;
export const JIHVA_OPTIONS = ['Upaliptha', 'Anupalipta'] as const;
export const SABDAM_OPTIONS = ['Ksheenam', 'Samam', 'Vishamam'] as const;
export const SPARSHAM_OPTIONS = ['Ushnam', 'Sheetam', 'Anushnasheetam'] as const;
export const DRIK_OPTIONS = ['Samanya', 'Malinata'] as const;
export const AKRITHI_OPTIONS = ['Sthoulyam', 'Madhyamam', 'Krisham'] as const;

export const PRAKRUTHI_DOSHA_OPTIONS = [
  'Vatha',
  'Pitha',
  'Kapha',
  'Vathakapha',
  'Vathapitha',
  'Kapha Pitha',
  'Sannipatika',
] as const;

export const AAMA_OPTIONS = ['Present', 'Absent'] as const;
